
<script lang="ts">
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CouponMixin from './mixin.vue';
import { i18n } from '../i18n';
import { CouponTipsType, ThemeColor } from '../types';

@Component
export default class CouponMixinV2 extends mixins(CouponMixin) {
  ThemeColor = ThemeColor;
  /** 主题色 */
  get themeColor() {
    return this.couponInfo.themeColor || ThemeColor.green;
  }
  /** 格式化券包张数 */
  get pkgCount() {
    // @ts-ignore
    return i18n('X张', { pkgCount: this.couponInfo.pkgCount });
  }
  /** 格式化折扣券数值 */
  get prizeDiscount() {
    return this.isEn ? `${this.couponInfo.prizeDiscount}%` : this.couponInfo.prizeDiscount;
  }
  /** 折扣券英文数值样式，小于 10 的正整数 */
  get numberEnFontStyle() {
    const reg = /^[1-9]$/;
    // @ts-ignore
    return this.isEn && reg.test(this.couponInfo.prizeDiscount) ? 'l' : '';
  }
  /** 覆盖 mixin --- 折扣券单位：英文-off;中文-折 */
  // @ts-ignore
  get discountUnitWithLang() {
    return this.isEn ? 'OFF' : '折';
  }
  /** 覆盖 mixin --- 是否展示手动开启提示 */
  // @ts-ignore
  get isShowManualTips() {
    return this.couponInfo.tipsType === CouponTipsType.manual;
  }
  /** 覆盖 mixin --- 是否展示连锁提示（使用后领取下一张） */
  // @ts-ignore
  get isShowChainTips() {
    return this.couponInfo.tipsType === CouponTipsType.chain;
  }
  /** 覆盖 mixin --- 是否展示银行专属 */
  // @ts-ignore
  get isShowBankTips() {
    return this.couponInfo.tipsType === CouponTipsType.bank;
  }
}
</script>
